import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { Icon } from '@pella/sash-framework';

const SearchField = ({ placeholder, onFocus, className, showSearchIcon, showReset, disableNavigate, onInputChange }) => {
	const { query, refine } = useSearchBox();
	const { results } = useInstantSearch();
	const [inputValue, setInputValue] = useState(query);

	useEffect(() => {
		let params = new URL(window.location).searchParams;
		let queryParam = params.get('query');

		if (queryParam) {
			setInputValue(queryParam);
			refine(queryParam);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- componentDidMount
	}, []);

	useEffect(() => {
		if (!inputValue || inputValue === query) return;

		const delaySearch = setTimeout(() => refine(inputValue), 200);
		return () => clearTimeout(delaySearch);
	}, [inputValue, query, refine]);

	const onSearchInputChange = (event) => {
		setInputValue(event.currentTarget.value);
		if (typeof onInputChange === 'function') onInputChange(event.currentTarget.value);
	};

	const onSearchFormSubmit = (event) => {
		event.preventDefault();

		if (results.renderingContent?.redirect?.url) {
			if (results.renderingContent.redirect.url.includes('http')) {
				window.open(results.renderingContent.redirect.url, '_blank');
			} else {
				navigate(results.renderingContent.redirect.url);
			}
		} else {
			if (disableNavigate) return;
			navigate(`/search/?query=${inputValue}`);
		}
	};

	const onResetClick = () => {
		setInputValue('');
		refine('');
	};

	return (
		<form
			className='relative'
			onSubmit={onSearchFormSubmit}
			noValidate
		>
			<input
				type='search'
				id='siteSearch'
				name='siteSearch'
				aria-label='Search pella.com'
				onChange={onSearchInputChange}
				onFocus={onFocus}
				value={inputValue}
				placeholder={placeholder}
				className={className}
			/>

			{showSearchIcon && (
				<Icon
					name='search'
					className='absolute left-2.5 top-1/2 block -translate-y-1/2 sm:left-4 lg:!text-32px'
				/>
			)}

			<button
				type='submit'
				className='sr-only'
				aria-label='Search Submit'
			>
				Submit
			</button>

			{showReset && query?.length > 0 && (
				<button
					type='reset'
					className='absolute right-2.5 top-1/2 -translate-y-1/2 sm:right-5'
					onClick={onResetClick}
					aria-label='Clear Search'
				>
					<Icon
						name='close'
						className='block text-gray-55 hover:text-gray-80 lg:!text-3xl'
					/>
				</button>
			)}
		</form>
	);
};

SearchField.propTypes = {
	placeholder: PropTypes.string,
	onFocus: PropTypes.func,
	className: PropTypes.string,
	showSearchIcon: PropTypes.bool,
	showReset: PropTypes.bool,
	disableNavigate: PropTypes.bool,
	onInputChange: PropTypes.func,
};

export default SearchField;
